import { useState } from 'react';
import axios from 'axios';
import { BASE_URL } from '../constants/urls';

export default function useGetNamesSlugsStores() {
    const [dataStores, setData] = useState([]);

    const [loadingStores, setLoading] = useState(false);
    const [errorStores, setError] = useState(null);

    const fetchDataStores = async (name, limit) => {
        setLoading(true);
        setError(null);

        try {

            const url = `${BASE_URL}/store/names-slugs?limit=${limit}&name=${encodeURIComponent(name)}`;

            const res = await axios.get(url, {
                headers: { Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}` }
            });
            setData(res.data);

        } catch (err) {
            if (axios.isAxiosError(err)) {
                setError(err.response?.data?.message || err.message);
            } else {
                setError('Erro desconhecido');
            }
        } finally {
            setLoading(false);
        }
    };

    return { dataStores, loadingStores, errorStores, fetchDataStores};
}